<div class="fullscreen" [ngClass]="{ maximized: isFullscreen }">
  <div class="barra-toogle">
    <button
      (click)="toggleFullscreen()"
      *ngIf="isFullscreen"
      type="button"
      class="btn-govco outline-btn-govco"
    >
      Minimizar Pantalla
      <img
        src="assets/icons/close_fullscreen.svg"
        alt="Conoce el CIMA"
        style="width: 13px !important"
      />
    </button>
    <button
      (click)="toggleFullscreen()"
      *ngIf="!isFullscreen"
      type="button"
      class="btn-govco outline-btn-govco"
    >
      Maximizar Pantalla
      <img
        src="assets/icons/expand-arrows-alt.svg"
        alt="Conoce el CIMA"
        style="width: 13px !important"
      />
    </button>
  </div>
  <ng-content></ng-content>
</div>
